// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {ForumLandingFormModuleLayout} from 'app_components/modules/admin/landings/forumLandingForm'
import PermissionService from 'app_services/secure/permission/permissionService'
import { I18nUtil } from 'app_utils/i18n'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
import LandingService from 'app_services/admin/landings/landingService'
import { ILangingForums } from 'app_types/admin/landings/landingTypes'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface IForumLandingFormModuleProps {
  forumData: ILangingForums
  source: string
  onHandleForumSubmit: (data: any) => void | null
}
interface IForumLandingFormModuleState {
  loading: boolean
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ForumLandingFormModule extends Component<IForumLandingFormModuleProps, IForumLandingFormModuleState> {

  public moduleName: string = 'module:landings'
  private permission: PermissionService
  private i18nUtil: I18nUtil
  private screenNotifications: ScreenNotificationsUtil
  private landingService: LandingService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IForumLandingFormModuleProps) {
    super(props)
    this.state = {
      loading: false
    }

    this.permission = new PermissionService(this.moduleName)
    this.i18nUtil = new I18nUtil()
    this.screenNotifications = new ScreenNotificationsUtil()
    this.landingService = new LandingService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  public handleSubmit = async (data: ILangingForums) => {
    if (!data) return
    this.setState({loading: true})
    const response = await this.landingService.saveForums({
      ...data,
      slug: this.props.source
    })
    if (response) {
      this.props.onHandleForumSubmit({status: 'success'})
    }
    this.setState({loading: false})
  }

  render() {
    return(
      <ForumLandingFormModuleLayout
        {...this.props}
        permission={this.permission}
        onHandleForumSubmit={this.permission.check(`permission:landings_${this.props.source}_forums`, this.handleSubmit)}
        loading={this.state.loading}
      />
    )
  }
}

export default connect(mapStatesToProps)(ForumLandingFormModule)
